export default __webpack_public_path__ + "static/media/Tabl_15.9c3b7fcf.svg";